import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Lock } from 'lucide-react';
interface PhoneStepProps {
  onNext: (phone: string) => void;
  defaultValue?: string;
}
export function PhoneStep({
  onNext,
  defaultValue = ''
}: PhoneStepProps) {
  const [phone, setPhone] = useState(defaultValue);
  const handlePhoneChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    let val = e.target.value.replace(/\D/g, '');
    if (val.length > 10) val = val.slice(0, 10);
    let formatted = val;
    if (val.length > 6) {
      formatted = `(${val.slice(0, 3)}) ${val.slice(3, 6)}-${val.slice(6)}`;
    } else if (val.length > 3) {
      formatted = `(${val.slice(0, 3)}) ${val.slice(3)}`;
    } else if (val.length > 0) {
      formatted = `(${val}`;
    }
    setPhone(formatted);
  };
  const isValid = phone.replace(/\D/g, '').length === 10;
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (isValid) onNext(phone);
  };
  return <div className="w-full max-w-md mx-auto px-4 py-1 sm:py-4" data-id="element-182">
      <div className="text-center mb-3 sm:mb-5" data-id="element-183">
        <h2 className="text-xl sm:text-3xl font-bold text-dark mb-1" data-id="element-184">
          ¿Cuál es tu número de teléfono?
        </h2>
      </div>
      <div className="bg-green-50 border border-green-200 rounded-lg p-2 mb-3 flex items-center gap-2" data-id="element-185">
        <div className="w-2.5 h-2.5 bg-green-500 rounded-full animate-pulse flex-shrink-0" data-id="element-186"></div>
        <p className="text-green-800 text-xs sm:text-sm font-medium" data-id="element-187">
          Un agente está disponible por poco tiempo
        </p>
      </div>

      <form onSubmit={handleSubmit} className="space-y-3" data-id="element-188">
        <input type="tel" value={phone} onChange={handlePhoneChange} placeholder="(555) 123-4567" className="w-full p-3.5 bg-white rounded-lg border-2 border-gray-200 focus:border-primary focus:ring-0 outline-none text-xl text-center tracking-wider transition-colors" required data-id="element-189" />
        <motion.button whileHover={{
        scale: isValid ? 1.02 : 1
      }} whileTap={{
        scale: isValid ? 0.98 : 1
      }} type="submit" disabled={!isValid} className="w-full bg-primary hover:bg-primary-hover text-white font-bold text-base py-3.5 px-6 rounded-lg shadow-md transition-colors disabled:opacity-50 disabled:cursor-not-allowed" data-id="element-190">
          Seguir
        </motion.button>
      </form>

      <div className="mt-2 text-center text-xs text-gray-500 flex items-center justify-center gap-1" data-id="element-191">
        <Lock className="w-3 h-3" data-id="element-192" />
        <span data-id="element-193">Tu información está cifrada y segura</span>
      </div>
    </div>;
}